import type { ButtonHTMLAttributes, DetailedHTMLProps, FC } from 'react';
import React from 'react';
import cn from 'classnames';

import styles from './transparent-button.css';

export const TransparentButton: FC<
    DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>
> = ({ className, ...props }) => <button className={cn(styles.button, className)} {...props} />;
